module.exports = __webpack_public_path__ + "static/media/urbano.6919d609.jpg";